<form [formGroup]='nameEmailPhone'
      [class]='this.formService.mainForm.controls["_customerId"].value ? "reduced-spacing" : ""'
      (ngSubmit)='onSubmit()'
      id='{{formGroupName}}'>

	<div class='beforeSubmit' *ngIf='!this.formService.formLoading'>

		<div class='step-title' i18n>
			Almost there! <span class='color-blue'>Where</span> can we send the <span class='color-blue'>quotes?</span>
		</div>

		<div class='form-control'>
			<mat-form-field class='name-input'>
				<mat-label i18n='@@labelName'>Name</mat-label>
				<input matInput
					   formControlName='name'
					   name='name'
					   autocomplete='name'
					   placeholder='e.g. John Smith'
					   i18n-placeholder
					   (blur)='verifyName($event)'
					   [autocomplete]='formService.autoFillProtection( formGroupName )'
					   [tabIndex]='formService.verifyTabIndex( formGroupName )'
					   type='text'>
			</mat-form-field>
			<mat-error *ngIf="formService.mainForm.get('nameEmailPhone')!.get('name')!.hasError('invalidName')" i18n>Please enter your full name.</mat-error>
			<mat-hint *ngIf="formService.mainForm.get('nameEmailPhone')!.get('name')!.hasError('invalidName')" i18n>e.g. John Smith</mat-hint>
		</div>

		<div class='form-control'>
			<mat-form-field>
				<mat-label i18n='@@labelEmail'>Email</mat-label>
				<input matInput
				       formControlName='email'
				       name='email'
				       class='user-data-email'
				       placeholder=''
				       (blur)='verifyEmail($event)'
				       [autocomplete]='formService.autoFillProtection( formGroupName )'
				       [tabIndex]='formService.verifyTabIndex( formGroupName )'
				       type='email'/>
			</mat-form-field>
			<mat-error *ngIf="formService.mainForm.get('nameEmailPhone')!.get('email')!.hasError('zeroBounceInvalid') || formService.mainForm.get('nameEmailPhone')!.get('email')!.hasError('invalidEmail')">
				<span i18n>Your email address appears to be invalid.</span>
				<div *ngIf="emailBounceDidYouMean"><ng-container i18n>Did you mean</ng-container>&nbsp;<a href='#' (click)='useDidYouMeanEmail($event)'>{{this.emailBounceDidYouMean}}</a>?</div>
			</mat-error>
		</div>

		<div class='form-control with-flags'>
			<mat-form-field class='phone-number-field'
			                [class]='!nameEmailPhone.controls["_shouldShow"].value ? "hide-for-tabindex" : ""'>
				<mat-label i18n='@@labelPhoneNumber'>Phone number</mat-label>

				<input type='hidden'
				       formControlName='phoneNumberComplete'
				       #phoneNumberComplete/>

				<!-- This one is hidden -->
				<div matPrefix
				     class='icon-prefix-padding phone-number-flags'>
					<input type='text'
					       formControlName='phoneNumberPlaceholder'
					       id='intl-tel-input'
					       #intlInputEl>
				</div>

				<input matInput
				       formControlName='phoneNumber'
				       name='phoneNumber'
				       placeholder=''
				       class='user-data-phone'
				       (blur)='verifyPhoneNumber($event)'
				       (input)='onPhoneNumberInput($event)'
				       [autocomplete]='formService.autoFillProtection( formGroupName )'
				       [tabIndex]='formService.verifyTabIndex( formGroupName )'
				       type='tel'>
			</mat-form-field>
			<mat-error *ngIf="formService.mainForm.get('nameEmailPhone')!.get('phoneNumber')!.hasError('invalidPhoneNumber') || formService.mainForm.get('nameEmailPhone')!.get('phoneNumber')!.hasError('invalidPhoneNumber')">
				<span i18n>Your phone number appears to be invalid.</span>
			</mat-error>
		</div>

		<div *ngIf='this.formService.mainForm.controls["_customerId"].value' class='form-control'>
			<mat-checkbox formControlName='nonExclusiveLead'
			              [tabIndex]='formService.verifyTabIndex( this.formGroupName )'
						  [checked]=true
			              i18n>
				Compare up to 4 other movers (Recommended)
			</mat-checkbox>
		</div>

		<div class='form-disclaimer'>
			<ng-container i18n>We'll only share your details with <a (click)='getPossibleMatchesPopup()'>your matched moving companies</a>. For more information, read our <a href='{{getPrivacyPolicyUrl()}}' class='disclaimer-link' target='_blank' [tabIndex]='formService.verifyTabIndex( this.formGroupName )'>Privacy Policy</a>.</ng-container>
		</div>

		<div class='step-footer step-footer-center'>
			<div class='step-footer-buttons'>
				<button class='back'
				        type='button'
				        (click)='formService.backMainForm()'>
					<mat-icon svgIcon='icons:chevron-left'></mat-icon>
					<ng-container i18n='@@buttonBack'>Back</ng-container>
				</button>

				<div class='data-secured'>

					<img class='data-secured-icon' src='./assets/images/lock.png' />
					<div class='data-secured-text' i18n='@@disclaimerSecure'>Your information is 100% secure</div>

				</div>

				<button class='submit final'
				        type='submit'>
					<ng-container i18n='@@buttonFinish'>Get quotes</ng-container>
					<mat-icon svgIcon='icons:chevron-right'></mat-icon>
				</button>
			</div>

		</div>

	</div>

	<div class='afterSubmit' *ngIf='this.formService.formLoading'>

		<div class='loader'>
			<div class='loader-spinner'></div>
		</div>

	</div>

</form>
